import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchBuildProjects = createAsyncThunk(
  "buildProjects/fetch",
  async () => {
    const { data } = await api.get("/build-projects");
    return data.projects;
  },
);

const buildProjectsSlice = createSlice({
  name: "buildProjects",
  initialState: {
    items: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuildProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBuildProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchBuildProjects.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default buildProjectsSlice.reducer;
